import { Component } from '@angular/core';

@Component({
    selector: 'error-network',
    templateUrl: './network.component.html',
    styles: []
})
export class NetworkComponent {
    constructor() { }
}